import { useMutation, useQueryClient } from '@tanstack/react-query';
import { apiFetch } from '../api/apiClient';
import { DatosContacto, RespuestaCheckout } from '../types/pedido';
import { obtenerCartSessionId, reiniciarCartSessionId } from '../storage/cartSessionStorage';

/** US-04: crea el pedido y devuelve el enlace de redirección a WhatsApp. */
export function useCrearPedido() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: (contacto: DatosContacto) => {
      const sessionId = obtenerCartSessionId();
      return apiFetch<RespuestaCheckout>('/pedidos', {
        method: 'POST',
        body: { sessionId, contacto },
      });
    },
    onSuccess: () => {
      // El backend ya vació el carrito del lado servidor; se genera un sessionId
      // nuevo para la siguiente visita (evita reutilizar uno ya finalizado).
      const anterior = obtenerCartSessionId();
      queryClient.removeQueries({ queryKey: ['carrito', anterior] });
      reiniciarCartSessionId();
    },
  });
}
